import type { ErrorRegistryShape } from '../common/common.error';

export const ROUND_ERROR = {
  NOT_FOUND_ROUND: { status: 404, message: 'Round not found' },
  /** 한 포트폴리오에 진행 중(종료일 없음) 라운드는 하나 */
  CONFLICT_ROUND_IN_PROGRESS: { status: 409, message: 'Another round is in progress' },
  /** D3 투자가 묶인 라운드는 지울 수 없다 */
  CONFLICT_ROUND_IN_USE: { status: 409, message: 'Round has investments' },
  /** 검사와 저장 사이에 다른 요청이 수정하려던 외부 투자자 행을 지웠다. 다시 불러와 다시 저장한다 */
  CONFLICT_ROUND_CHANGED: { status: 409, message: 'Round was changed by another request' },
} as const satisfies ErrorRegistryShape;
